import { createTheme, lighten, ThemeOptions } from '@mui/material/styles/';
import { appFonts } from './App.fonts';
import { appClasses } from './App.classes';
import { appPalette } from './App.palette';
import { appBreakpoints } from './App.breakpoints';
import { hondaFonts } from './fonts/hondaFontStyles';

const { white, acura_red, black } = appPalette.colors;
const appTheme = process.env.REACT_APP_THEME;
const overrides: ThemeOptions['components'] = {
  //Globals
  MuiCssBaseline: {
    styleOverrides: {
      html: {
        fontSize: '16px',
      },
      body: {
        backgroundColor: white,
        '&.fixed-body': {
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          position: 'fixed',
        },
      },
      // Font load with fallbacks, reported bug: https://github.com/mui-org/material-ui/issues/24966
      fallbacks: Object.values(appFonts).map((item) => {
        return {
          '@font-face': item,
        };
      }),
      ...appClasses,
      ...(appTheme === 'honda' && hondaFonts),
    },
  },
  // Buttons
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 0,
        fontSize: '0.875rem',
        fontFamily: `AvenirNextDemi`,
        fontWeight: 'normal',
        lineHeight: 1.43,
        letterSpacing: '0.02625rem',
      },
      containedPrimary: {
        backgroundColor: acura_red,
        color: white,
        '&:hover': {
          backgroundColor: acura_red,
          color: white,
        },
      },
      outlined: {
        borderWidth: '0.0625rem',
        borderColor: black,
        color: black,
      },
      outlinedPrimary: {
        borderWidth: '0.125rem',
        borderColor: acura_red,
        color: black,
        '&:hover': {
          borderWidth: '0.125rem',
          color: black,
          borderColor: acura_red,
        },
      },
    },
  },
  MuiTouchRipple: {
    styleOverrides: {
      child: {
        backgroundColor: lighten(acura_red, 0.7),
      },
    },
  },
};

export const theme = createTheme({
  themeName: appTheme,
  spacing: (factor: number) => `${0.5 * factor}rem`,
  typography: {
    fontFamily: 'AvenirNextLight, Roboto, Helvetica, Arial, sans-serif',
  },
  breakpoints: appBreakpoints,
  palette: appPalette,
  components: overrides,
});
